import { render, staticRenderFns } from "./ElementBaseInfo.vue?vue&type=template&id=9389bee0&"
import script from "./ElementBaseInfo.vue?vue&type=script&lang=js&"
export * from "./ElementBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports